function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "line chart"
}, React.createElement("rect", {
  id: "\xE7\x9F\xA9\xE5\xBD\xA2",
  opacity: 0.01,
  width: 20,
  height: 20,
  fill: "white"
}), React.createElement("path", {
  id: "\xE5\xBD\xA2\xE7\x8A\xB6",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.90625 15.4688H17.3438C17.4297 15.4688 17.5 15.5391 17.5 15.625V16.7188C17.5 16.8047 17.4297 16.875 17.3438 16.875H2.65625C2.57031 16.875 2.5 16.8047 2.5 16.7188V3.28125C2.5 3.19531 2.57031 3.125 2.65625 3.125H3.75C3.83594 3.125 3.90625 3.19531 3.90625 3.28125V15.4688ZM6.19336 12.4551C6.13086 12.5156 6.0332 12.5156 5.97266 12.4551L5.20117 11.6797C5.14062 11.6191 5.14062 11.5195 5.20117 11.459L8.79102 7.89062C8.85156 7.83008 8.95117 7.83008 9.01172 7.89062L11.5 10.3945L15.9922 5.9043C16.0527 5.84375 16.1523 5.84375 16.2129 5.9043L16.9863 6.67773C17.0469 6.73828 17.0469 6.83789 16.9863 6.89844L11.6074 12.2754C11.5469 12.3359 11.4473 12.3359 11.3867 12.2754L8.89453 9.76758L6.19336 12.4551Z",
  fill: "white"
}));

var SvgTrendingUp = function SvgTrendingUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrendingUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TrendingUp.4e8e64ec.svg";
export { ForwardRef as ReactComponent };